@if (showAppShell) {
  <app-shell>
    <router-outlet (activate)="scrollTopNavContent()"></router-outlet>
  </app-shell>
  } @else {
  <main>
    <router-outlet (activate)="scrollTopNavContent()"></router-outlet>
  </main>
  }